import { render, staticRenderFns } from "./SelectedInfo.vue?vue&type=template&id=09d6fe04&"
import script from "./SelectedInfo.vue?vue&type=script&lang=js&"
export * from "./SelectedInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports